import React, { useEffect, useState } from "react"
import { CustomButton, SectionHeader } from "../GlobalComponents/CommonComponents"
import CustomAccordion from "../GlobalComponents/CustomAccordion"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"
// import Textarea from './TextArea';
import UserRegistrationModal from "./UserRegistrationModal"
import { getUsersByRole } from "../../services/userServices"
import { Box } from "@mui/material"
import { getFullName } from "../../utils/Helpers"
import { CONSULTANT } from "../../utils/constants"

const ConsultantSection = (props) => {
  const {
    formData,
    handleChange,
    options,
    activeModal,
    setActiveModal,
    onCloseModal,
  } = props.data
  let modalData = {}
  const [selectedConsultant, setSelectedConsultant] = useState(null)

  useEffect(() => {
    if (selectedConsultant && formData.consultant !== selectedConsultant) {
      handleChange({ target: { name: "consultant", value: selectedConsultant } })
    }

  }, [selectedConsultant])

  useEffect(() => {
    getUsers(formData?.consultant)
  }, [])

  const [gpData, setGPData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  async function getUsers(id = "") {
    try {
      // const data = await getUsersByRole({ role: "GP" })
      const data = await getUsersByRole({
        role: [CONSULTANT],
      })
      console.log("onnasdfsadf data--23 formData", data, formData, id)
      setIsLoading(false)

      if (data?.userDetails) {
        const newGPData = data?.userDetails?.map((each) => {
          if (each?._id === id) {
            console.log("onnasdfsadf", id, each)
            setSelectedConsultant(each)

            handleChange({ target: { name: "consultant", value: each } })
            // const { name, value } = e.target;
          }
          let label = getFullName(each)

          return { ...each, label, value: each }
        })

        setGPData(newGPData)
      } else {
        setGPData([])
      }
    } catch (error) {
      setGPData([])
    }

    setIsLoading(false)
  }

  function handleConsultantChange(e) {
    console.log("handleGPChange", e.target.value)
    const { name, value } = e.target
    setSelectedConsultant(e.target.value)
    handleChange(e)
  }

  console.log("props ConsultantSection", props?.data?.formData)

  // const value = handleChange
  function handleSectionChange(e) {
    const { name, value } = e.target
    let val = value?._id
    console.log("props ConsultantSection", e, e.target, val)
    // setFormData({
    //   ...formData,
    //   [name]: value,
    // })
    // handleChange({ target: { name, value: val } })
  }

  return (
    <Box
      style={{
        width: "100%",
        borderRadius: "5px",
      }}
    >
      <SectionHeader title="Consultant" />

      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          type="dropdown"
          label="Consultant"
          options={gpData}
          name="consultant"
          value={selectedConsultant}
          onChange={handleConsultantChange}
          placeholder="Consultant"
        />
      </Box>
    </Box>
  )
}

export default ConsultantSection
